import translate from '@translate';
import React, { FC, useState, ReactNode } from 'react';
import { ExportIcon } from 'src/components/SkladonIcon/SmallIcons';
import { ExportTypeType } from 'src/types/table';
import { getActionElement } from '../ActionsMenu';
import Button from '../Button';
import ConfirmDialog, { ConfirmDialogStatePropsType } from '../ConfirmDialog';
import { OptionType } from '../Select';

export interface ExportTableActionPropsType {
    title: string;
    handleExport: (type: ExportTypeType) => void;
    icon?: ReactNode;
    textWithIcon?: boolean;
}

const exportOptions: OptionType[] = [
    { label: 'CSV', value: 'CSV' },
    { label: 'XLSX', value: 'XLSX' },
];

const ExportTableAction: FC<ExportTableActionPropsType> = (props) => {
    const [confirmParams, setConfirmParams] = useState<ConfirmDialogStatePropsType | null>(null);

    const onClick = () => {
        setConfirmParams({
            title: props.title,
            content: translate('table.downloadFormat'),
            optionsValue: exportOptions[0].value,
            action: (value: ExportTypeType) => {
                props.handleExport(value);
            },
        });
    };
    return (
        <>
            {props.textWithIcon ? (
                getActionElement(
                    { icon: <ExportIcon />, label: props.title, tooltip: props.title, onClick },
                    onClick,
                    true
                )
            ) : (
                <Button
                    onClick={onClick}
                    variant={props.textWithIcon ? 'text' : 'outlined'}
                    tooltiop={props.title}
                    fullWidth={props.textWithIcon}
                >
                    {props.icon ? props.icon : <ExportIcon />}
                </Button>
            )}
            {confirmParams && (
                <ConfirmDialog
                    title={confirmParams.title}
                    content={confirmParams.content}
                    action={confirmParams.action}
                    onClose={() => setConfirmParams(null)}
                    options={exportOptions}
                    optionsValue={confirmParams.optionsValue}
                />
            )}
        </>
    );
};

export default ExportTableAction;
